import { Col, ColType, Crud, CrudOption, CrudApi } from "../../comp/crud";
import { formatDate } from "../../utils";
import LeadImportLogDetail from "./indexDetail";
import { IconModalStroked } from "@douyinfe/semi-icons";
import { Modal, Typography, Toast } from "@douyinfe/semi-ui";
import { ApiClient } from "../../api/ApiClient";
import React, { useEffect, useMemo, useState } from "react";

const geImportResultOpts = async (): Promise<CrudOption[]> => {
  const statusOpts: any = [
    {
      label: "成功",
      value: "1",
      key: 1,
    },
    {
      label: "失败",
      value: "0",
      key: 0,
    },
  ];
  return statusOpts;
};

export default function LeadImportLog() {
  const [detailShow, setDetailShow] = useState(false);
  const [batchNo, setBatchNo] = useState("");
  const [importResult, setImportResult] = useState(null as null | any);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);

  let apiClient = ApiClient.getDefault();
  let rootPri = false;
  const role = localStorage.getItem("role");
  if (role == "root" || role == "op_manager") {
    rootPri = true;
  } else {
    rootPri = false;
  }

  let cols: Col[] = [
    {
      name: "批次号",
      key: "batchNo",
      hideInList: false,
      showInFilter: true,
      type: ColType.STRING,
    },

    {
      name: "渠道",
      key: "source",
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "总数",
      key: "total",
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportLogModal(record.batchNo, null);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "成功",
      key: "success",
      hideInEdit: true,
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportLogModal(record.batchNo, 1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "失败",
      key: "fail",
      hideInEdit: true,
      showInFilter: false,
      type: ColType.STRING,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadImportLogModal(record.batchNo, 0);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "导入人",
      key: "createdByName",
      showInFilter: true,
      type: ColType.STRING,
    },
  ];
  const openLeadImportLogModal = async (
    batchNo: string,
    importResult: number | null
  ) => {
    setBatchNo(batchNo);
    setImportResult(importResult);
    setDetailShow(true);
  };

  let nowDate = new Date();
  const initFilterValues = {
    //createdAt: [nowDate, nowDate],
  };

  let startDateStr = formatDate(nowDate);
  let endDateStr = formatDate(nowDate);
  const initParams = {
    //createdAt: startDateStr + "," + endDateStr,
  };

  const deleteRow = (batchNo: number) => {
    Modal.confirm({
      title: "是否确认删除？",
      content: "",
      onOk: async () => {
        try {
          await apiClient.request<boolean>(
            "/leadImportLog/deleteByBatchNo?batchNo=" + batchNo,
            "DELETE"
          );
          Toast.info("删除成功");

          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  return (
    <>
      <Modal
        icon={
          <IconModalStroked size={"extra-large"} style={{ color: "blue" }} />
        }
        title={"导入结果明细"}
        fullScreen={true}
        headerStyle={{
          flexShrink: 0, // 关键属性 2：固定标题
          borderBottom: "1px solid var(--semi-color-border)",
        }}
        bodyStyle={{
          overflow: "auto", // 关键属性 3：启用内容滚动
          flex: 1,
        }}
        footer={null}
        hasCancel={false}
        onCancel={() => setDetailShow(false)}
        onOk={() => setDetailShow(false)}
        visible={detailShow}
      >
        <div>
          <LeadImportLogDetail batchNo={batchNo} importResult={importResult} />
        </div>
      </Modal>
      <Crud
        getCrudApi={(crudApi) => {
          setCrudApi(crudApi);
        }}
        canUpdate={false}
        canCreate={false}
        name="导入日志"
        entityKey="leadImportLog/listTask"
        initFilterValues={initFilterValues}
        initParams={initParams}
        getRowActions={(a) => {
          if (rootPri) {
            return [
              {
                name: "删除",
                action: () => {
                  deleteRow(a.batchNo);
                },
              },
            ];
          } else {
            return [];
          }
        }}
        pageSize={50}
        cols={cols}
      />
    </>
  );
}
